// extracted by mini-css-extract-plugin
module.exports = {"container":"app-module__container___3hyN6","main":"app-module__main___1M2gf","footerFix":"app-module__footerFix___eojWV"};